import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,{staticClass:"mb-6"},[_c(VCardTitle,[_vm._v(" "+_vm._s(_vm.t('Escuelas'))+" ")]),_c('school-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }